document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('[data-testimonials-slider]');

  sliders.forEach((slider) => {
    const viewport = slider.querySelector('.testimonials-slider__viewport');
    const track = slider.querySelector('.testimonials-slider__track');
    const slides = Array.from(track.querySelectorAll('.testimonial-card'));
    const prevBtn = slider.querySelector('[data-slider-prev]');
    const nextBtn = slider.querySelector('[data-slider-next]');
    const dotsWrap = slider.querySelector('[data-slider-dots]');

    if (!viewport || !track || slides.length === 0) return;

    let currentIndex = 0;
    let autoplay = slider.dataset.autoplay === 'true';
    let autoplaySpeed = parseInt(slider.dataset.speed || '5000', 10);
    let interval = null;
    let slidesPerView = getSlidesPerView();
    let maxIndex = Math.max(0, slides.length - slidesPerView);

    let isDragging = false;
    let dragStarted = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID = null;
    let movedBy = 0;

    function getSlidesPerView() {
      const width = window.innerWidth;
      if (width <= 749) return 1;
      if (width <= 989) return 2;
      if (width <= 1199) return 3;
      return 4;
    }

    function getGap() {
      const styles = window.getComputedStyle(track);
      return parseFloat(styles.columnGap || styles.gap || 0);
    }

    function getStepSize() {
      const slideWidth = slides[0].offsetWidth;
      const gap = getGap();
      return slideWidth + gap;
    }

    function getCurrentOffsetByIndex(index) {
      return index * getStepSize();
    }

    function setSliderPosition() {
      track.style.transform = `translate3d(${currentTranslate}px, 0, 0)`;
    }

    function animation() {
      setSliderPosition();
      if (isDragging) {
        animationID = requestAnimationFrame(animation);
      }
    }

    function updateSlider(animate = true) {
      slidesPerView = getSlidesPerView();
      maxIndex = Math.max(0, slides.length - slidesPerView);

      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      const offset = getCurrentOffsetByIndex(currentIndex);

      track.style.transition = animate ? 'transform 0.45s ease' : 'none';
      currentTranslate = -offset;
      prevTranslate = currentTranslate;
      setSliderPosition();

      updateDots();
    }

    function goTo(index) {
      if (index < 0) {
        currentIndex = maxIndex;
      } else if (index > maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex = index;
      }

      updateSlider(true);
    }

    function createDots() {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = '';
      const totalPages = maxIndex + 1;

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonials-slider__dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          goTo(i);
          restartAutoplay();
        });
        dotsWrap.appendChild(dot);
      }

      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      const dots = dotsWrap.querySelectorAll('.testimonials-slider__dot');
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    function startAutoplay() {
      if (!autoplay || maxIndex <= 0) return;
      stopAutoplay();
      interval = setInterval(() => {
        goTo(currentIndex + 1);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (interval) {
        clearInterval(interval);
        interval = null;
      }
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function startDrag(clientX) {
      isDragging = true;
      dragStarted = true;
      startX = clientX;
      movedBy = 0;
      prevTranslate = -getCurrentOffsetByIndex(currentIndex);
      currentTranslate = prevTranslate;

      viewport.classList.add('is-dragging');
      track.style.transition = 'none';

      stopAutoplay();

      cancelAnimationFrame(animationID);
      animationID = requestAnimationFrame(animation);
    }

    function onDragMove(clientX) {
      if (!isDragging) return;
      const currentPosition = clientX;
      movedBy = currentPosition - startX;
      currentTranslate = prevTranslate + movedBy;
    }

    function endDrag() {
      if (!isDragging) return;

      isDragging = false;
      viewport.classList.remove('is-dragging');
      cancelAnimationFrame(animationID);

      const threshold = getStepSize() * 0.18;

      if (movedBy < -threshold && currentIndex < maxIndex) {
        currentIndex += 1;
      } else if (movedBy > threshold && currentIndex > 0) {
        currentIndex -= 1;
      }

      updateSlider(true);

      setTimeout(() => {
        dragStarted = false;
      }, 50);

      restartAutoplay();
    }

    function handleDragStart(e) {
      const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      startDrag(clientX);
    }

    function handleDragMove(e) {
      if (!isDragging) return;
      const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
      onDragMove(clientX);
    }

    function handleDragEnd() {
      endDrag();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        goTo(currentIndex - 1);
        restartAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        goTo(currentIndex + 1);
        restartAutoplay();
      });
    }

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', () => {
      if (!isDragging) startAutoplay();
    });

    viewport.addEventListener('mousedown', handleDragStart);
    viewport.addEventListener('touchstart', handleDragStart, { passive: true });

    window.addEventListener('mousemove', handleDragMove);
    window.addEventListener('touchmove', handleDragMove, { passive: true });

    window.addEventListener('mouseup', handleDragEnd);
    window.addEventListener('touchend', handleDragEnd);

    viewport.addEventListener('dragstart', (e) => e.preventDefault());

    viewport.addEventListener('click', (e) => {
      if (Math.abs(movedBy) > 6 || dragStarted) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const oldMaxIndex = maxIndex;
        slidesPerView = getSlidesPerView();
        maxIndex = Math.max(0, slides.length - slidesPerView);

        if (oldMaxIndex !== maxIndex) {
          createDots();
        }

        updateSlider(false);
      }, 120);
    });

    createDots();
    updateSlider(false);
    startAutoplay();
  });
});